import { render } from "./Entrance.vue?vue&type=template&id=492a1a22&scoped=true&bindings={\"nextStep\":\"options\",\"onVideoEnd\":\"options\",\"onClick\":\"options\"}"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"

import "./Entrance.vue?vue&type=style&index=0&id=492a1a22&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-492a1a22"

export default script